import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden; /* evita scroll horizontal no layout inteiro */
`;

export const Sidebar = styled.aside`
  width: 250px;
  flex: 0 0 250px;      /* largura fixa, não encolhe */
  background: #FFF;
  color: #1a1a1a;
  padding: 20px 0 100px; /* espaço extra no rodapé para não colidir com botão flutuante */
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* permite rolar caso a lista ultrapasse a altura */

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1200;
    transform: ${({ $open }) => ($open ? 'translateX(0)' : 'translateX(-100%)')};
    transition: transform 0.25s ease-out;
    box-shadow: ${({ $open }) => ($open ? '2px 0 12px rgba(0,0,0,0.12)' : 'none')};
  }
`;

export const SidebarClose = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: inline-flex;
    align-self: flex-end;
    margin: 8px 16px 0 0;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
`;

export const Logo = styled.div`
  padding: 0 20px;
  margin-bottom: 30px;
  
  img {
    max-width: 150px;
  }
`;

export const MenuItem = styled.div`
  a {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    color: ${props => props.$active ? '#fff' : '#999'};
    text-decoration: none;
    transition: all 0.3s ease;
    background: ${props => props.$active ? '#34574A' : 'transparent'};

    &:hover {
      background: #34574A;
      color: #fff;
    }

    svg {
      margin-right: 10px;
      font-size: 18px;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  min-width: 0;            /* permite reduzir dentro do flex */
  overflow: hidden;        /* impede que filhos forcem scroll global */

  main {
    padding: 20px;
    flex: 1;
    min-width: 0;          /* importante para conter elementos largos */
    overflow: hidden;      /* o scroll horizontal deve ficar dentro das páginas */
  }
`;

export const Header = styled.header`
  background: #fff;
  padding: 15px 30px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const MobileToggle = styled.button`
  display: none;
  margin-right: auto;
  font-size: 22px;
  line-height: 1;

  @media (max-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  span {
    color: #333;
    font-weight: 500;
  }
`; 